<template>
    <div>
        <skupovi-navigation
            :id="skup_id"
            :breadcrumbs="breadcrumbs"
        >
        </skupovi-navigation>
        <div class="ibox">
            <div class="ibox-title">
                <h5>Tema: {{ naziv }}</h5>
            </div>
            <div class="ibox-content">
                <skup-tema-forma
                    :disabled="true"
                    :id="id"
                    :modal="false"
                    :action="'show'"
                    @returnData="setData"
                >
                </skup-tema-forma>
            </div>
        </div>
    </div>
</template>

<script>
import SkupoviNavigation from "../SkupNavigation";
import SkupTemaForma from "./SkupTemaForma";
export default {
    name: "SkupTemaDetails",
    components: { SkupTemaForma, SkupoviNavigation },
    data(){
        return {
            breadcrumbs: [],
            id:this.$route.params.tema_id,
            skup_id: this.$route.params.skup_id,
            naziv: ''
        }
    },
    methods: {
        setBreadcrumbs(){
            this.breadcrumbs = [
                {
                    path: '/skupovi/' + this.skup_id + '/teme',
                    name: 'Teme'
                },
                {
                    path: '/skupovi/' + this.skup_id + '/teme/' + this.id,
                    name: 'Tema: ' + this.naziv
                }
            ]
        },
        setData( data ){
            this.naziv = data.naziv
            this.setBreadcrumbs()
        }
    }
};
</script>

<style scoped>

</style>
